import { HostStatus } from '@/infra/sse/status'
import { useStatusContext } from '@/features/status'

export function useHostStatus(hostname: string): HostStatus | null {
  const { getHostStatus } = useStatusContext()
  return getHostStatus(hostname)
}
